export function deepMerge<T>(...objects: T[]): T {
  const mergeRecursive = (target: any, source: any): any => {
    if (isObject(target) && isObject(source)) {
      const merged: any = { ...target };
      for (const key in source) {
        if (isObject(source[key])) {
          merged[key] = mergeRecursive(target[key], source[key]);
        } else {
          merged[key] = source[key];
        }
      }
      return merged;
    }
    return source;
  };
  return objects.reduce((acc, obj) => mergeRecursive(acc, obj), {} as T);
}

function isObject(obj: any): obj is Record<string, any> {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}

export class ObjectAssigner {
  static create<T>(init: Partial<T>): T {
    const value = {};
    Object.assign(value, init);
    return value as T;
  }
}
